import { makeAPIRequest, QueryParams } from '../utils/request'
import type { SubmitAnswer, QuestionResponse, QuestionsResponse } from './question.types'
import { API_ENDPOINTS } from '../utils/endpoints'

const QUESTIONS_API_VERSION = '4'

/**
 * Fetch all active questions,  optional userId parameter to tell backend to return with user answer or not
 */
export async function fetchActiveQuestions(
  year: number,
  userId?: string | null
): Promise<QuestionsResponse> {
  const params: QueryParams = {
    isActive: true,
    year,
  }
  try {
    const qRes = await makeAPIRequest(API_ENDPOINTS.QUESTIONS, {
      method: 'GET',
      apiVersion: QUESTIONS_API_VERSION,
      queryParams: params,
      useAuthToken: !!userId,
    })
    if (qRes?.error) {
      qRes.error?.message && console.error(qRes.error?.message)
      return {
        questions: [],
        error: qRes.error?.message ?? null,
      }
    }
    return {
      questions: qRes?.data,
      error: null,
    }
  } catch (error) {
    return {
      questions: [],
      error: 'Error fetching questions.',
    }
  }
}

/**
 * Fetch single question
 */
export async function fetchQuestionsGroup(
  questionGroup: string,
  userId?: string | null
): Promise<QuestionsResponse> {
  let params: QueryParams = {
    group: questionGroup,
  }
  try {
    let qRes = await makeAPIRequest(API_ENDPOINTS.QUESTIONS, {
      method: 'GET',
      apiVersion: QUESTIONS_API_VERSION,
      queryParams: params,
      useAuthToken: !!userId,
    })
    if (qRes?.error) {
      qRes.error?.message && console.error(qRes.error?.message)
      return {
        questions: [],
        error: qRes.error?.message ?? null,
      }
    }
    return {
      questions: qRes?.data,
      error: null,
    }
  } catch (error) {
    return {
      questions: [],
      error: 'Error fetching groupquestions.',
    }
  }
}

/**
 * Fetch single question
 */
export async function fetchSingleQuestion(
  questionId: string,
  userId?: string | null
): Promise<QuestionResponse> {
  try {
    let qRes = await makeAPIRequest(`${API_ENDPOINTS.QUESTIONS}/${questionId}`, {
      method: 'GET',
      apiVersion: QUESTIONS_API_VERSION,
      useAuthToken: !!userId,
    })
    if (qRes?.error) {
      qRes.error?.message && console.error(qRes.error?.message)
      return {
        question: null,
        error: qRes.error?.message ?? null,
      }
    }
    return {
      question: qRes?.data,
      error: null,
    }
  } catch (error) {
    return {
      question: null,
      error: 'Error fetching question.',
    }
  }
}

/**
 * Submit user answer
 */
export async function submitAnswer(
  questionId: number,
  userId: string,
  answerCode: string
): Promise<SubmitAnswer> {
  if (!userId)
    return {
      question: null,
      error: 'You must be logged in to submit an answer.',
    }
  try {
    const qRes = await makeAPIRequest(
      `${API_ENDPOINTS.QUESTIONS}/${questionId}/answer`,
      {
        method: 'POST',
        apiVersion: QUESTIONS_API_VERSION,
        body: JSON.stringify({
          answerCode,
        }),
        useAuthToken: true,
      }
    )
    if (qRes?.error) {
      qRes.error?.message && console.error(qRes.error?.message)
      return {
        question: null,
        error: qRes.error?.message,
      }
    }
    return {
      question: qRes?.data,
      error: '',
    }
  } catch (error) {
    return {
      question: null,
      error: 'Error submitting answer.',
    }
  }
}
